/**
 * @fileoverview Barrel exports for the single-chapter-drafter agent.
 *
 * This module provides a co-located agent following the agent-per-folder pattern:
 * - definition.ts: Agent metadata and configuration
 * - schema.ts: Input/output Zod schemas
 * - prompt.ts: Handlebars prompt template
 * - flow.ts: Genkit flow implementation
 *
 * This is the short-form counterpart to chapter-drafter-v2. It drafts a complete
 * short story rather than one chapter of a multi-chapter narrative.
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  type Input,
  type Output,
} from './schema';

// Flow
export { flow, singleChapterDrafterAgentFlow } from './flow';

// Prompt template
export { prompt } from './prompt';
